import { TreatmentType } from 'it/primatoo/openapi/api/org/schemas/treatmentdoc/TreatmentType';

export class TreatmentTypesConverter {
  static ofWorkspaceItemType(type: 'TREATMENT_SUB_RESPONSIBLE' | 'TREATMENT_HOLDER' | 'TREATMENT_PROJECT' | 'TREATMENT_RESPONSIBLE'): TreatmentType {
    switch (type) {
      case 'TREATMENT_RESPONSIBLE':
        return TreatmentType.RESPONSIBLE;
      case 'TREATMENT_HOLDER':
        return TreatmentType.HOLDER;
      case 'TREATMENT_PROJECT':
        return TreatmentType.PROJECT;
      default:
        return TreatmentType.SUB_RESPONSIBLE;
    }
  }
}
